module.exports = __webpack_public_path__ + "static/media/3DPPA3.955b4418.jpg";